import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Note } from '../../../../helbest';
import styles from './Dataform.module.css';
// import AddressMap from "../Map/AddressMap";

const Dataform = ({
  item,
  region_list,
  region,
  set_region,
  addr,
  set_addr,
  zip_code,
  set_zip_code,
  edit_address,
  set_address,
  set_address_editable,
  isInEditPage,
  new_addr
}) => {
  const history = useHistory();
  const store = useSelector((state) => state);

  return (
    <div>
      <div className={styles.FormContainer}>
        <div className={styles.container}>
          <div className={styles.Label}>استان</div>
          <select
            className={styles.SelectContainer}
            disabled
            onChange={(value) => console.log(value)}>
            <option>{store.Login.province_name}</option>
          </select>
          <div className={` mar-r-20 ${styles.Label}`}>شهر</div>
          <select
            className={styles.SelectContainer}
            disabled
            onChange={(value) => console.log(value)}>
            <option>{store.Login.city_name}</option>
          </select>
        </div>
        <div className={styles.container}>
          <label className={styles.Label}>منطقه</label>
          <select
            className={
              region_list.length < 1
                ? 'select-input disabled address-select-input'
                : 'select-input address-select-input'
            }
            disabled={region_list.length < 1}
            onChange={(e) => set_region(e.target.value)}>
            {item?.region_id ? (
              <option value={item.region_id}> {item.region} </option>
            ) : (
              <option selected value="" />
            )}
            {region_list.map((x, i) => (
              <option key={i} value={x.id}>
                {' '}
                {x.name}{' '}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.container}>
          <label className={styles.Label}>کدپستی</label>
          <div className="center-name-input-container">
            <input
              className="center-name-input"
              maxLength={10}
              onChange={(e) => {
                set_zip_code(e.target.value);
              }}
              value={zip_code}
            />
          </div>
        </div>

        <div className={styles.container}>
          <textarea
            className="textarea-input mb-2 address-location-input"
            onChange={(e) => set_addr(e.target.value)}
            placeholder="آدرس را بدون استان، شهر و منطقه وارد کنید"
            rows="3"
            value={addr}
          />
        </div>

        {/* <br />

      <div className="form-row map-reletive">
        <AddressMap lat={lat} lng={lng} set_lat={set_lat} set_lng={set_lng} />
      </div> */}
      </div>
      <div className="page-address-new-address-box">
        <button
          onClick={() => {
            if (item?.id && set_address_editable) {
              set_address_editable('');
            } else if (new_addr) {
              new_addr('new');
            } else if (isInEditPage) {
              history.push('/delivery/');
            }
          }}
          type="button">
          لغو
        </button>
        <button
          onClick={() => {
            if (addr === '') {
              Note.error('لطفا آدرس خود را وارد کنید');
            } else if (region === '') {
              Note.error('لطفا منطقه خود را انتخاب کنید');
            } else if (zip_code === '') {
              Note.error('لطفا کد پستی خود را وارد کنید');
            } else {
              item?.id ? edit_address(item?.id) : set_address();
            }
          }}
          type="button">
          ثبت
        </button>
      </div>
    </div>
  );
};

export default Dataform;
